export default "/assets/images/reading-girl-placeholder.f4d71c2e51258162.webp";